import { render, staticRenderFns } from "./JQuickItem.vue?vue&type=template&id=455625da&scoped=true"
import script from "./JQuickItem.vue?vue&type=script&lang=js"
export * from "./JQuickItem.vue?vue&type=script&lang=js"
import style0 from "./JQuickItem.vue?vue&type=style&index=0&id=455625da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455625da",
  null
  
)

export default component.exports